module.exports = __webpack_public_path__ + "static/bg_asset-556e9a8dd368e478f4ff7bfbb26847a5.jpg";